import styled from 'styled-components';

export const Tr = styled.tr`
  &:nth-child(n) {
    text-align: center;
  }
`;

export const InputTable = styled.input`
  max-width: 4.5rem;
  border: 1px solid #e9ecef;
  outline: none;
  height: 1.9rem;

  border-radius: 3px;
  padding: 0 0.3rem;
  color: #525f7f;
  text-align: center;
  background: ${(props) => (props.editable ? 'auto' : 'none')};
`;
